













































































































































import BaseFilter from "@/components/Filter/BaseFilter";
import { IncomingTariffsFilterParams } from "@/store/tarification/incoming_tariffs/types";
import { Component, Prop, PropSync } from "vue-property-decorator";
import {
  DatePickerWings,
  FastDateDetailWings,
  SelectWings,
  NumberWings,
} from "wings-ui-components";
import { Action, Getter } from "vuex-class";
import { notifyError } from "@/utils/notify-helper";
import { AccountItem } from "@/store/settings/accounts/types";
import { ServiceProviderItem } from "@/store/settings/service_providers/types";
import { MsgTransports } from "@/store/types";
import {getTranslatedParams} from "@/utils/notify-utils";

@Component({
  components: {
    FastDateDetailWings,
    DatePickerWings,
    SelectWings,
    NumberWings,
  },
})
export default class IncomingTariffsFilter extends BaseFilter<IncomingTariffsFilterParams> {
  @PropSync("show") is_show!: boolean;
  @Prop() transport!: MsgTransports;

  @Action("getIncomingTariffs") actionGetItems: any;
  @Action("getPartners") actionGetPartners: any;
  @Action("getServiceProviders") actionGetServiceProviders: any;
  @Action("getAccounts") actionGetAccounts: any;

  defaultFilter(): IncomingTariffsFilterParams {
    return new IncomingTariffsFilterParams();
  }

  storageItemName(): string {
    return `${this.transport}IncomingTariffsFilter`;
  }

  params = { transport: this.transport };
  transportFilter = { transport: this.transport };
  partnersList: any = []
  serviceProvidersList: any = []
  accountsList: any = []

  async getPartnersList(filter: any) {
    const items = await this.actionGetPartners({...this.params, ...filter});
    this.partnersList = (filter?.page_number > 1) ? this.partnersList.concat(items) : items
  }

  async getServiceProvidersList(filter: any) {
    const items = await this.actionGetServiceProviders({...this.params, ...filter});
    this.serviceProvidersList = (filter?.page_number > 1) ? this.serviceProvidersList.concat(items) : items
  }

  async getAccountsList(filter: any) {
    const items = await this.actionGetAccounts({...this.params, ...filter});
    this.accountsList = (filter?.page_number > 1) ? this.accountsList.concat(items) : items
  }

  async created() {
    this.filtered();
    if (this.filter.partner) this.partnersList = await this.actionGetPartners({name: this.filter.partner});
    if (this.filter.broker_account) this.accountsList = await this.actionGetAccounts({login: this.filter.broker_account});
    if (this.filter.service_provider) this.serviceProvidersList = await this.actionGetServiceProviders({name: this.filter.service_provider});
  }

  async onFilteredAction() {
    console.log('this.$route.meta.msgKey = ', this.$route.meta.msgKey);
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "The rule for routing incoming messages",
        addititional_info: getTranslatedParams(this.filter)
      };
      await this.actionGetItems({
        filter: this.filter,
        transport: this.transport,
      });
      await this.actionLog(this.logObject);
    } catch (err) {
      await this.actionLog({...this.logObject, action_status: "failed"});
      notifyError(err);
    }
  }
}
